import { render, staticRenderFns } from "./ReportMaterialsRequestMaterial.vue?vue&type=template&id=9cec26f4&"
import script from "./ReportMaterialsRequestMaterial.vue?vue&type=script&lang=js&"
export * from "./ReportMaterialsRequestMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QIcon,QItem,QItemLabel,QItemSection,QList,QInput,QSeparator,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QIcon,QItem,QItemLabel,QItemSection,QList,QInput,QSeparator,QCardActions,QBtn}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
